import { useEffect } from 'react'

import commonRepo from '@/repository/common.repo'
import { quickMenuService } from '@/service/quickMenu.service'

export const useQuickMenuSetting = () => {
  useEffect(() => {
    if (commonRepo.academy && commonRepo.isSchoolflat) {
      if (quickMenuService.isReady) return
      quickMenuService.init()
    }
  }, [commonRepo.academy, commonRepo.isSchoolflat])
}
